"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/alt-text */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const UI_1 = require("~/components/UI");
const consts_1 = require("~/store/consts");
const useWindowDimensions_1 = __importDefault(require("~/hooks/useWindowDimensions"));
const types_1 = require("~/store/types");
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const redux_1 = require("redux");
const actions_1 = require("~/store/actions");
const assets_1 = require("~/assets");
const PreconfiguredFramesWidget_scss_1 = __importDefault(require("./PreconfiguredFramesWidget.scss"));
const PreconfiguredFramesButton_1 = require("./PreconfiguredFramesButton");
const PreconfiguredFramesField_1 = require("./PreconfiguredFramesField");
const PreconfiguredFrameWidget_helper_1 = require("./PreconfiguredFrameWidget.helper");
const HEADER_KEY_BY_TYPE = {
    [types_1.IVisibleFrameType.BOX_ITEM]: 'Box Configurations',
    [types_1.IVisibleFrameType.FRAME_ITEM]: 'Frame Configurations',
    [types_1.IVisibleFrameType.DOOR_ITEM]: 'Door Configurations',
    [types_1.IVisibleFrameType.DEFAULT]: 'Default title',
};
function PreconfiguredFramesWidget() {
    const { t } = (0, react_i18next_1.useTranslation)('widgets');
    const { height } = (0, useWindowDimensions_1.default)();
    const visibleFrame = (0, react_redux_1.useSelector)(selectors_1.selectVisibleFrame);
    const fields = (0, react_redux_1.useSelector)(selectors_1.selectFormFields);
    const commonstate = (0, react_redux_1.useSelector)(selectors_1.selectFormState);
    const { dispatchToggleVisibleFrame, dispatchToggleWidget } = (0, redux_1.bindActionCreators)({
        dispatchToggleVisibleFrame: actions_1.toggleVisibleFrame,
        dispatchToggleWidget: actions_1.toggleWidget,
    }, (0, react_redux_1.useDispatch)());
    const onSave = () => {
        (0, PreconfiguredFrameWidget_helper_1.GetPreconfiguredPayload)(visibleFrame, commonstate);
        dispatchToggleWidget({
            widgetName: consts_1.WIDGETS.PRECONFIGURED_FRAMES_WIDGET,
            show: false,
        });
    };
    return (react_1.default.createElement(UI_1.Widget, { widgetName: consts_1.WIDGETS.PRECONFIGURED_FRAMES_WIDGET, defaultSize: {
            width: 336,
            height: 436,
        }, minSize: {
            width: 336,
            height: 416,
        }, defaultPosition: {
            x: 16,
            y: height - 524,
        } },
        react_1.default.createElement("div", { className: PreconfiguredFramesWidget_scss_1.default.widget }, visibleFrame === types_1.IVisibleFrameType.DEFAULT ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("header", { className: PreconfiguredFramesWidget_scss_1.default.header },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: PreconfiguredFramesWidget_scss_1.default.title }, t('preconfigured-frames.header')))),
            react_1.default.createElement("main", { className: PreconfiguredFramesWidget_scss_1.default['default-main'] },
                react_1.default.createElement(PreconfiguredFramesButton_1.PreconfiguredFramesButton, { label: "Box", onClick: () => dispatchToggleVisibleFrame(types_1.IVisibleFrameType.BOX_ITEM), imageURI: "/assets/box.JPG" }),
                react_1.default.createElement(PreconfiguredFramesButton_1.PreconfiguredFramesButton, { label: "Frame", onClick: () => dispatchToggleVisibleFrame(types_1.IVisibleFrameType.FRAME_ITEM), imageURI: "/assets/frame.png" }),
                react_1.default.createElement(PreconfiguredFramesButton_1.PreconfiguredFramesButton, { label: "Door", onClick: () => dispatchToggleVisibleFrame(types_1.IVisibleFrameType.DOOR_ITEM), imageURI: "/assets/door.png" })))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("header", { className: PreconfiguredFramesWidget_scss_1.default['items-header'] },
                react_1.default.createElement("button", { type: "button", className: PreconfiguredFramesWidget_scss_1.default['back-button'], onClick: () => dispatchToggleVisibleFrame(types_1.IVisibleFrameType.DEFAULT) },
                    react_1.default.createElement("img", { src: assets_1.svgLightChevronLeft, role: "presentation" }),
                    HEADER_KEY_BY_TYPE[visibleFrame]),
                react_1.default.createElement("button", { type: "button", className: PreconfiguredFramesWidget_scss_1.default['place-button'], onClick: onSave }, "Place")),
            react_1.default.createElement("div", { className: PreconfiguredFramesWidget_scss_1.default['form-main'] }, fields.map((field) => {
                return react_1.default.createElement(PreconfiguredFramesField_1.PreconfiguredFramesField, { key: field, name: field });
            })))))));
}
exports.default = PreconfiguredFramesWidget;
